import { render } from "./AppCosti.vue?vue&type=template&id=61085e9d&scoped=true"
import script from "./AppCosti.vue?vue&type=script&lang=js"
export * from "./AppCosti.vue?vue&type=script&lang=js"

import "./AppCosti.vue?vue&type=style&index=0&id=61085e9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61085e9d"]])

export default __exports__